import { type FC } from 'react';
import { Stack, Text } from '@mantine/core';
import { formatOrder, type PayinOrder } from '~/entities/payin';
import { KeyValuePair } from '~/shared/ui/KeyValuePair';
import { CopyInput } from '~/shared/ui/CopyInput';
import { Requisites } from './components';

interface OrderProps {
    order: PayinOrder;
}

export const OrderDetails: FC<OrderProps> = ({ order }) => {
    return (
        <Stack
            align='stretch'
            gap='xs'
        >
            {order.id?.value && (
                <KeyValuePair
                    label='ID'
                    value={<CopyInput value={order.id?.value} />}
                />
            )}

            {order.amount?.value && (
                <KeyValuePair
                    label='Сумма'
                    value={<CopyInput value={order.amount.value} />}
                />
            )}

            {order.currency && (
                <KeyValuePair
                    label='Валюта'
                    value={<Text>{formatOrder.currency(order.currency)}</Text>}
                />
            )}

            {order.rate?.value && (
                <KeyValuePair
                    label='Курс'
                    value={<Text>{order.rate?.value}</Text>}
                />
            )}

            {order.status && (
                <KeyValuePair
                    label='Статус'
                    value={<CopyInput value={formatOrder.status(order.status)} />}
                />
            )}

            {order.publicStatus && (
                <KeyValuePair
                    label='Публичный статус'
                    value={<CopyInput value={formatOrder.publicStatus(order.publicStatus)} />}
                />
            )}

            {order.createdAt && (
                <KeyValuePair
                    label='Дата создания'
                    value={<Text>{formatOrder.date(order.createdAt)}</Text>}
                />
            )}

            {order.expiresAt && (
                <KeyValuePair
                    label='Дата истечения'
                    value={<Text>{formatOrder.date(order.expiresAt)}</Text>}
                />
            )}

            {order.traderName?.value && (
                <KeyValuePair
                    label='Трейдер'
                    value={order.traderName.value}
                />
            )}

            {order.requisite && <Requisites requisites={order.requisite} />}
        </Stack>
    );
};
